import { get } from 'utils/http';
import { BASE_URL } from 'constants/env';
import { withCache } from 'utils/fetch-cache';

export const PUBLISH_STATUS_SWR_KEY = '/cms/catalog/publish-status';

/**
 * Gets the possible publish status from the database
 *
 * @returns {Promise<PublishStatus[]>}
 */
export const getAllPublishStatus = () => {
    return withCache(`${BASE_URL}/cms/catalog/publish-status`, get).then((result = {}) => result.objects);
};
